export default "__VITE_ASSET__Cve9bmKW__ 78w";